import { Injectable } from '@angular/core';
import { IndexModel } from 'digiteq-ai-portal-client-lib';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CompanyChatService {
  $indexChange = new Subject<IndexModel>();

  private _daiseIndex?: IndexModel;
  get daiseIndex(): IndexModel {
    const localStorageDaiseIndex = localStorage.getItem('daiseIndex');
    if (localStorageDaiseIndex) {
      this._daiseIndex = JSON.parse(localStorageDaiseIndex);
    }
    return this._daiseIndex;
  }

  set daiseIndex(value: IndexModel) {
    this._daiseIndex = value;
    localStorage.setItem('daiseIndex', JSON.stringify(value));
    this.$indexChange.next(value);
  }

  get daiseHeading(): string {
    let heading = 'DAISE';
    this._daiseIndex = this.daiseIndex;
    if (this._daiseIndex?.name) {
      heading += ' - ' + this._daiseIndex.name;
    }
    return heading;
  }
}
